import styled from "styled-components";

import { LinkButton } from "../../Subscriptions/Banner/index.style";

const primaryColor = "#0171b9";

export const ContactContainer = styled.div`
  background-color: white;
  color: ${primaryColor};
  padding: 2em 0;

  h3 {
    text-transform: uppercase;
    text-align: center;
    max-width: 50ch;
    line-height: 1.2;
    margin-bottom: 1em;
  }

  @media (min-width: 800px) {
    .flex-rows-break::after {
      content: "";
      width: 1px;
      height: calc(100% + 6rem);
      background-color: #e4e4e4;
      display: block;
      transform: translateY(-3rem);
    }

    .col + .col {
      margin-left: 3em;
    }
    padding: 5em 0;
  }
`;

export const Row = styled.div`
  @media (min-width: 800px) {
    display: flex;
    justify-content: space-between;
  }
`;

export const Col = styled.div``;

export const Button = styled(LinkButton)`
  max-width: 150px;
  border-radius: 100em;
  color: ${primaryColor};
  border: 2px solid ${primaryColor};
  box-shadow: none;
  text-transform: none;
  display: block;
  margin: 0 auto;
  background-color: white;

  &:link,
  &:visited {
    color: ${primaryColor};
  }

  &:hover,
  &:focus {
    box-shadow: none;
    background-color: ${primaryColor};
    color: white;
  }
}
`;
